export default "__VITE_ASSET__Do3fyiQq__"